export default function CustomButton(props) {
  // Standard across Base is `inputRef`; `buttonRef` kept as an alias so
  // any existing callers using the old name keep working unchanged.
  const resolvedRef = props.inputRef || props.buttonRef;
  return (
    <div className="btn-wrapper ">
      <button
        id=""
        className={`${props.cstmClass} enterfocus`}
        onClick={props.buttonHandler}
        ref={resolvedRef}
        disabled={props.disable}
        // readOnly={props.readOnly}
      >
        {props.label}
      </button>
    </div>
  );
}
 